import ContractIterationItemModel from 'Models/sales/ContractIterationItemModel';
import doc                        from 'decorators/doc';
import model                      from 'decorators/model';
import { Timestampable }          from 'helpers/traits';
import { Blamable }               from 'helpers/traits';
import SalesPrivateApiModel       from 'modelx/models/abstracts/SalesPrivateApiModel';
import moment                     from 'moment';
import { getWeekdayName }         from 'tools/Weekdays';

@model.staticLabel('ContractIterationItemScheduleConstraint')
@model.urnResource('contract_iteration_item_schedule_constraint')
@doc.path('/contract_iteration_item_schedule_constraints/{?id}')
export default class ContractIterationItemScheduleConstraintModel extends Blamable(Timestampable(SalesPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'contractIterationItem': id;
		'contractIterationItem.contractIteration': id;
	}> = {};

	public _sorts: ModelSortsExtended<unknown> = {};

	@doc.model(ContractIterationItemModel) declare contractIterationItem: ContractIterationItemModel;
	@doc.date declare endTime: Moment;
	@doc.date declare startTime: Moment;
	@doc.number declare weekday: number;

	public get itemId() {
		return this.get('contractIterationItem.id', '0');
	}

	get name() {
		return (
			getWeekdayName(this.weekday)
			+ ` de `
			+ moment(this.get('startTime'), 'HH:mm:ss').format('HH:mm')
			+ ` à `
			+ moment(this.get('endTime'), 'HH:mm:ss').format('HH:mm')
		);
	}
}